import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import { Package } from "lucide-react"
import { ProductAttribute } from "@/types/product-type"

interface ProductAttributesTabProps {
  productAttributes: ProductAttribute[]
}

export function ProductAttributesTab({ productAttributes }: ProductAttributesTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Product Attributes</CardTitle>
        <CardDescription>Customizable attributes for this product</CardDescription>
      </CardHeader>
      <CardContent>
        {productAttributes.length > 0 ? (
          <div className="space-y-4">
            {productAttributes.map((attribute) => (
              <div key={attribute.id} className="p-4 border rounded-lg">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-medium">{attribute.displayName}</h4>
                  <Badge variant="outline">{attribute.type}</Badge>
                </div>
                <p className="text-sm text-muted-foreground mb-2">
                  <strong>Name:</strong> {attribute.name}
                </p>
                <div className="text-xs text-muted-foreground">
                  ID: {attribute.id}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <Package className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
            <h3 className="text-lg font-semibold">No attributes yet</h3>
            <p className="text-muted-foreground mb-4">
              Create attributes to add customizable properties to this product.
            </p>
            <Button>Add Attribute</Button>
          </div>
        )}
      </CardContent>
    </Card>
  )
}
